var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKycDone240X240(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    viewBox: "0 0 240 240",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6912 131.63C28.6912 164.604 30.731 197.369 30.731 230.329L49.0884 231.349H91.6958C105.631 231.349 119.075 232.902 132.943 232.369C159.242 231.357 211.246 230.329 211.246 230.329C211.246 230.329 213.286 146.424 213.286 134.462C213.286 125.092 212.266 116.152 212.266 106.87C212.266 82.7425 211.891 54.5384 193.908 36.556C173.641 16.2888 144.471 8 116.399 8C107.578 8 99.749 9.77044 91.4692 12.1361C79.4817 15.5611 49.2063 33.714 43.1959 45.7348C33.6249 64.8769 27.6714 88.7507 27.6714 110.043C27.6714 117.353 28.6912 124.58 28.6912 131.63Z",
    fill: "#C8E6D9",
    stroke: "#1A2147",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6966 231.349C105.632 231.349 119.076 232.902 132.944 232.369C159.242 231.358 211.247 230.329 211.247 230.329C211.247 230.329 213.286 146.424 213.286 134.463C213.286 134.463 142.622 164.911 110.79 179.059C78.9571 193.207 30.7317 230.329 30.7317 230.329L49.0891 231.349H91.6966Z",
    fill: "#4FAD84",
    stroke: "#1A2147",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "bevel"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKycDone240X240);
export default __webpack_public_path__ + "static/media/kyc-done-240x240.a4d0719c49b8e3a70db7e8fb7aa09b32.svg";
export { ForwardRef as ReactComponent };